var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.938,
    height: 32.938,
    viewBox: "0 0 32.938 32.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111180",
    "data-name": "Path 111180",
    d: "M16.469-12.75a15.964,15.964,0,0,1-2.225,8.234,16.641,16.641,0,0,1-6.01,6.01A15.964,15.964,0,0,1,0,3.719,15.964,15.964,0,0,1-8.234,1.494a16.641,16.641,0,0,1-6.01-6.01,15.964,15.964,0,0,1-2.225-8.234,15.964,15.964,0,0,1,2.225-8.234,16.641,16.641,0,0,1,6.01-6.01A15.964,15.964,0,0,1,0-29.219a15.964,15.964,0,0,1,8.234,2.225,16.641,16.641,0,0,1,6.01,6.01A15.964,15.964,0,0,1,16.469-12.75ZM0-9.43a2.942,2.942,0,0,0-2.158.9,2.942,2.942,0,0,0-.9,2.158,2.942,2.942,0,0,0,.9,2.158A2.942,2.942,0,0,0,0-3.32a2.942,2.942,0,0,0,2.158-.9,2.942,2.942,0,0,0,.9-2.158,2.942,2.942,0,0,0-.9-2.158A2.942,2.942,0,0,0,0-9.43ZM-2.922-20.387l.531,9.031a.7.7,0,0,0,.232.5.768.768,0,0,0,.564.232H1.594a.768.768,0,0,0,.564-.232.7.7,0,0,0,.232-.5l.531-9.031a.852.852,0,0,0-.232-.631.768.768,0,0,0-.564-.232h-4.25a.768.768,0,0,0-.564.232A.852.852,0,0,0-2.922-20.387Z",
    transform: "translate(16.469 29.219)",
    fill: "#ff1c1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.a4a686bed2b9ae812a0ece4a91568133.svg";
export { ForwardRef as ReactComponent };